import { Box, Icon } from '@ksyos/design-system';

type ChoiceboxWithWarningProps = {
    label: string;
};

export function ChoiceboxWithWarning({ label }: ChoiceboxWithWarningProps): JSX.Element {
    return (
        <Box
            alignItems="center"
            display="flex"
            gap={2}
        >
            <Icon
                color="warning"
                icon="warning"
            />
            <span>{label}</span>
        </Box>
    );
}
